import * as Three from 'three';
import React from 'react';
import { lineBreakWord } from '../../../common/functions/helperFunctions';

const WIDTH = 30;
const DEPTH = 30;
const HEIGHT = 90;

export default {
    name: 'boiler',
    prototype: 'items',

    info: {
        tag: ['metal'],
        title: 'Boiler',
        description: 'Boiler',
        image: require('./boiler.PNG')
    },

    properties: {
        altitude: {
            label: 'altitude',
            type: 'length-measure',
            defaultValue: {
                length: 0,
                unit: 'cm'
            }
        }
    },

    render2D: function (element, layer, scene) {
        let style = { stroke: 'red', strokeWidth: element.selected ? '3px' : "2px", fill: "white" };
        let radius = 15;
        let angle = element.rotation + 90;
        let textRotation = 0;
        if (Math.sin(angle * Math.PI / 180) < 0) {
            textRotation = 180;
        }
        let desc = lineBreakWord(element.desc, 20);

        return (
            <g transform={`translate(${0},${0})`}>
                <circle key='1' cx='0' cy='0' r={radius} style={style} />
                <text key="2" x="0" y="0"
                    transform={`translate(${(radius / 2) - 5}, ${textRotation === 0 ? -20 : radius + 10}) scale(1,-1) rotate(${textRotation})`}
                    style={{ textAnchor: "middle", fontSize: "11px" }}>
                    {desc.map((r, index) => <tspan key={index + 'desc'} x="0" y={12 * (index + 1)}>{r}</tspan>)}
                </text>

            </g>
        )
    },


    render3D: function (element, layer, scene) {
        let mesh = new Three.Mesh();
        return Promise.resolve(mesh);
    },

    renderAxonomertic: function (element, layer, scene) {
        //let angle = element.rotation + 90;
        let textRotation = 0;
        let desc = lineBreakWord(element.desc, 20);
        let style = { stroke: element.selected ? '#000' : '#777', strokeWidth: "2px", fill: "white" }
        //let styleRight = { stroke: element.selected ? '#000' : '#777', strokeWidth: "2px", fill: "#ccc" }
        let styleFront = { stroke: element.selected ? '#000' : '#777', strokeWidth: "2px", fill: "#eee" }
        let styleRect = { fill: "#eee" }

        // if (Math.sin(angle * Math.PI / 180) < 0) {
        //     textRotation = 180;
        // }

        return (
            // no-rotation means that the item would not be rotated in src\components\viewerAxonometric\item.jsx!
            <g transform={`translate(${-WIDTH / 1.2}, 0)`} key='no-rotation'>
                {/* <rect key="1" x="0" y={-HEIGHT} width={WIDTH} height={HEIGHT} style={styleFront} />
                <g transform={`scale(1, 0.5) skewX(27)`}>
                    <rect key="2" x="0" y="0" width={WIDTH} height={DEPTH} style={style} />
                </g>
                <g transform={`translate(${WIDTH}, 0) skewY(45)`}>
                    <rect key="3" x="0" y={-HEIGHT} width={WIDTH / 2} height={HEIGHT} style={styleRight} />
                </g> */}
                <g>
                    <ellipse key="1" cx={WIDTH / 2} cy={-HEIGHT} rx="15" ry="10" style={styleFront}></ellipse>
                    <rect key="2" x="0" y={-HEIGHT} width={WIDTH} height={HEIGHT} style={styleFront} />
                    <rect key="3" x="1" y={-(HEIGHT + 2)} width={WIDTH - 2} height={20} style={styleRect}></rect>
                    <ellipse key="4" cx={WIDTH / 2} cy={0} rx="15" ry="10" style={style}></ellipse>
                </g>

                {element.productCount
                    ? <>
                        <path d={`M${WIDTH} -20 L${WIDTH + 50} 20`} style={{ stroke: '#777', strokeWidth: '2px' }} />
                        <path d={`M${WIDTH + 50} 20 L${WIDTH + 70} 20`} style={{ stroke: '#777', strokeWidth: '2px' }} />
                        <circle id="3" cx={`${WIDTH + 70}`} cy="20" r="17" style={{ stroke: '#777', fill: '#ffffff', strokeWidth: '2px' }} />
                        <text
                            x={`${WIDTH + 70}`}
                            y="-20"
                            fontFamily="Arial"
                            alignmentBaseline="middle"
                            textAnchor="middle"
                            fontSize={24}
                            fill="#000000"
                            transform={`scale(1,-1) rotate(${textRotation})`}
                        >
                            {element.productCount}
                        </text>
                    </>
                    : null}

                {/* <line key="4" x1="0" y1={-HEIGHT + 15} x2={WIDTH} y2={-HEIGHT + 15} stroke={element.selected ? '#000' : '#777'} strokeWidth="2px" /> */}
                <circle key="5" cx={10} cy={-HEIGHT + 7} r={3} style={style} />
                <circle key="6" cx={20} cy={-HEIGHT + 7} r={3} style={style} />
                {!element.productCount
                    ? <text key="10" x="0" y="0"
                        transform={`translate(${WIDTH + 5}, ${textRotation === 0 ? -2 : DEPTH + 5}) scale(1,-1) rotate(${textRotation})`}
                        style={{ textAnchor: "left", fontSize: "11px" }}>
                        {desc.map((r, index) => <tspan key={index + 'desc'} x="0" y={12 * (index + 1)}>{r}</tspan>)}
                    </text>
                    : null}

            </g>
        )
    }
};
